import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { formatChatItemDate } from '../../common/utils';
import { AiChatItemData } from '../../aiChatLayout/types';

@customElement('gz-chat-incident-update')
export class GzChatIncidentUpdateWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  message = '';

  @property({ type: Number, attribute: true, reflect: true })
  timestamp: number | null;

  static get styles() {
    return styles;
  }

  static fromAiChatItem(data: AiChatItemData): GzChatIncidentUpdateWebComponent {
    const component = new GzChatIncidentUpdateWebComponent();
    component.timestamp = data.created ?? null;
    component.message = data.message ?? '';
    return component;
  }

  render() {
    return html`
      <div class="main-container">
        <gz-text fontSize="10">${this.message}</gz-text>
        <gz-text fontSize="10">${this.timestamp ? formatChatItemDate(this.timestamp) : ''}</gz-text>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-chat-incident-update': GzChatIncidentUpdateWebComponent;
  }
}
